module.exports = __webpack_public_path__ + "static/media/calendar-icon.72f3717b.svg";